// Simple wrapper to avoid TypeScript issues with react-modal
import ReactModal from "react-modal";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useModalBodyScroll } from "../../hooks/useModalBodyScroll";

const Modal = (props) => {
  const { isOpen } = props;
  
  // Prevent body scroll when modal is open
  useModalBodyScroll(isOpen);

  useEffect(() => {
    ReactModal.setAppElement("body");
  }, []);

  return <ReactModal {...props} />;
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node,
  onRequestClose: PropTypes.func,
  style: PropTypes.object,
  ariaHideApp: PropTypes.bool,
  appElement: PropTypes.any,
  role: PropTypes.string,
};

export default Modal;
